import { motion } from 'motion/react'

import { m } from '~/paraglide/messages.js'
import { useParagraphReveal } from '~/components/use-paragraph-reveal'

import { MessageQuestionIcon } from './icons/message-question'

const revealSteps = [
  { selector: '[data-a="1"]', at: 1 },
  { selector: '[data-a="2"]', at: 2 },
] as const

export function Page4Content({
  revealed,
  skipNonce,
  onRevealsComplete,
}: {
  revealed: boolean
  skipNonce: number
  onRevealsComplete?: () => void
}) {
  const { scope } = useParagraphReveal({
    enabled: revealed,
    skipNonce,
    onComplete: onRevealsComplete,
    steps: revealSteps,
  })

  return (
    <motion.div
      ref={scope}
      className="flex w-full flex-1 flex-col justify-center gap-6 pb-6 text-base text-white"
    >
      <p
        data-a="1"
        className="whitespace-pre-line leading-[22px]"
        style={{ opacity: 0 }}
      >
        {m.pro_user_appreciation_letter_ending()}
      </p>
      <div
        data-a="2"
        className="flex w-full items-center gap-2 rounded-[20px] bg-white/[0.14] py-3 pl-4 pr-3"
        style={{ opacity: 0 }}
      >
        <MessageQuestionIcon className="size-6 shrink-0" />
        <p className="whitespace-pre-line text-sm text-white">
          {m.how_to_change_theme()}
        </p>
      </div>
    </motion.div>
  )
}
